import * as styles from './SearchSectionTitle.module.css'

/**
 * @typedef {object} SearchSectionTitleProps
 *
 * @property {string} [Element]
 * @property {React.ReactNode} [childreen]
 * @property {string} [className]
 */

/**
 * @param {SearchSectionTitleProps} props
 */
function SearchSectionTitle({
  Element = 'h3',
  children,
  className = styles.SearchSectionTitle,
  ...elementProps
}) {
  return (
    <Element {...elementProps} className={className}>
      {children}
    </Element>
  )
}

export default SearchSectionTitle
